<div class="card" aria-hidden="true">
  <div class="placeholder placeholder-glow placeholder__img"></div>
  <div class="card-header border-0 bg-white">
    <div class="row">
      <div class="col-8">
        <h3 class="card-title placeholder-glow">
          <span class="placeholder w-100"></span>
        </h3>
      </div>
      <div class="col-3">
        <div class="placeholder placeholder__logo rounded-4">
          <span class="placeholder w-100"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <h5 class="card-title placeholder-glow">
      <span class="placeholder col-6"></span>
    </h5>
    <p class="card-text placeholder-glow">
      <span class="placeholder col-4"></span>
      <span class="placeholder col-3"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-6"></span>
      <span class="placeholder col-8"></span>
    </p>
  </div>
</div>
